import { AfterContentChecked, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { Atto } from 'src/app/common/models/atto';
import { CreazionePraticaStoreService } from '../../services/creazione-pratica-store.service';
import { ElaborationDocumentFilterEntity } from 'src/app/document-management/models/elaboration-doc-filter';
import { TipoAtto } from 'src/app/common/models/tipologiche/tipo-atto';
import { CreazionePraticaTipologicheService } from '../../services/creazione-pratica-tipologiche.service';
import { stepMap } from '../creazione-pratica-stepper/config/step';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { OperationsService } from 'src/app/core/services/operations.service';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { DocumentoAddModal } from 'src/app/common/components/documenti/documento-add/documento-add-modal.component';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { DocumentVersionHistoryModal } from 'src/app/common/components/documenti/documento-history-version/document-version-history-modal.component';
import { DocumentVersionUpdateModal } from 'src/app/common/components/documenti/documento-version-update/document-version-update-modal.component';
import { DocumentUpdateMetadatiModal } from 'src/app/common/components/documenti/documento-update-metadati/document-update-metadati-modal.component';
import { ScadenzarioRequest } from 'src/app/common/models/scadenzario-request';
import { ScadenzaModAutoAddComponent } from 'src/app/common/components/fascicolo/scadenzario-auto-add/scadenza-mod-auto-add.component';
import { Scadenza } from 'src/app/common/models/scadenza';
import { UpdateMetadatiComponent } from 'src/app/common/components/fascicolo/documentazione-allegata-view/metadati/update-metadati/update-metadati.component';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { StepAttiFormComponent } from './step-atti-form/step-atti-form.component';
import { FascicoloFull } from 'src/app/common/models/fascicolo/fascicolo-full';

declare var closeModal: any;
@Component({
  selector: 'step-atti',
  templateUrl: './step-atti.component.html',
  styleUrls: ['./step-atti.component.css']
})
export class StepAttiComponent implements OnInit, OnDestroy,AfterContentChecked  {
  @ViewChild('bottom', { read: ElementRef }) bottom: ElementRef<HTMLElement>;

  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>()
  isShowForm: boolean = false;
  accordions = stepMap;
  sezione = null;
  fascicolo: FascicoloFull | null = null;
  atti: Atto[] = [];
  attoTmp: Atto = null;
  tipiAttiStore: ElaborationDocumentFilterEntity[];
  datePubblicazioniSuggerite: ElaborationDocumentFilterEntity[];
  dateDepositoSuggerite: ElaborationDocumentFilterEntity[];
  tipiAttiSuggeriti: TipoAtto[];
  attoToEdit: Atto;
  indexAttoToEdit: number;
  tipiAttoList: String[] = [];
  attiSuggeriti: Atto[] = [];
  attoAssociato: Atto;
  isScroll: boolean = false;
  isEdit = false;
  scadenze: Scadenza[] = [];
  @ViewChild('formAtti') formAtti!: StepAttiFormComponent;
  @ViewChild('docAddModalAtti') docAddModalAtti: DocumentoAddModal;
  @ViewChild('docVersionHistoryAtti') docVersionHistoryAtti: DocumentVersionHistoryModal;
  @ViewChild('docVersionUpdateModalAtti') docVersionUpdateModalAtti: DocumentVersionUpdateModal; 
  @ViewChild('attiScadenzaAutoAddModal') attiScadenzaAutoAddModal: ScadenzaModAutoAddComponent;

  constructor(
    private creazionePraticaStoreService: CreazionePraticaStoreService,
    private tipologicheService: CreazionePraticaTipologicheService,
    private operations: OperationsService,
    private dialog: DialogService
  ) {
    this.creazionePraticaStoreService.fascicoloLoad$.subscribe((fascicolo: FascicoloFull) => {
      if(fascicolo) {
        this.fascicolo = fascicolo;
      }
    })
    this.creazionePraticaStoreService._docAdd.subscribe(
      data => {
        if(data?.tipoSezione?.descrizione === "ATTI") {
            if(!!this.sezione) {
              this.sezione.documentiAggregati = data.documentiAggregati
              this.atti = [...data.atti];
              this.creazionePraticaStoreService.setAtti(data.atti);
              this.creazionePraticaStoreService.save();
            }
        }
      }
    )
  }

  ngOnInit() {
    this.readSezione();
    this.getAttiFromStore();

    this.tipologicheService.getTipiAtto().subscribe(tipiAtto => {
      this.tipiAttoList = tipiAtto.map(el => el.label);

      this.creazionePraticaStoreService.entities$.subscribe(entities => {

        //recupero entities etichettate com 'GIURISPRUDENZA', 'PUBLISH_DATA', 'DECISION_DATE'
        this.filterEntities(entities);

        //tra i tipi atto suggeriti, prendo solo quelli con valore valido (presenti in TPL_TIPI_ATTO)
        this.tipiAttiStore = this.tipiAttiStore.filter(el =>
          this.tipiAttoList.includes(el.valore)
        );

        //dal tipo atto suggerito (ElaborationDocumentFilterEntity[]) passo a tipoAtto (TipoAtto[])
        this.tipiAttiSuggeriti = tipiAtto.filter(el =>
          this.tipiAttiStore.map(attoStore => attoStore.valore).includes(el.label)
        );

        //costruisco gli atti suggeriti (tutte combinazioni di tipi atto, data pubblicazione e data deposito, ma deve esistere almeno un tipo atto)
        this.createAttiByEntities(this.tipiAttiSuggeriti, this.datePubblicazioniSuggerite,
          this.dateDepositoSuggerite);
      });
    });


    /*if(this.atti.length > 0) {
      this.isShowList = true;
    } else {
      this.isShowForm = true;
    }*/
    //TSR-652: Mostrare sempre la lista di default
    this.isShowForm = false;
  }

  ngOnDestroy(): void {
    this.creazionePraticaStoreService.setAtti(null);
    this.creazionePraticaStoreService.save();
  }

  ngAfterContentChecked(): void {
    if (this.isScroll) {
      this.scroll(this.bottom.nativeElement);
    }
  }

  ngAfterViewChecked(): void {
    if(this.isScroll){
      this.scroll(this.bottom.nativeElement);
      this.isScroll = false;
    }
  }

  getAttiFromStore() {
    this.creazionePraticaStoreService.atti$.subscribe((atti => {
      if(!atti){
        this.creazionePraticaStoreService.setAtti([]);
      }
      else {
        this.atti = atti ? atti : [];
      }
    }));
  }

  onFormAtto() {
    this.isShowForm = true;
    this.isEdit = false
    this.formAtti.inizializza(false);
  }

  onShowList() {
    this.getAttiFromStore();
    this.isShowForm = false;
  }

  onSave(atto: Atto) {
    this.attoTmp = atto;
    //se aggiungo atto
    // if(this.attoToEdit === undefined) {
    //   this.creazionePraticaStoreService.addAtto(atto);
    //   this.attoToEdit = undefined;
    //   this.attoAssociato = undefined;
    // }
    // else {
    //   //se modifico un atto esistente
    //   this.atti[this.indexAttoToEdit] = atto;
    //   this.creazionePraticaStoreService.setAtti(this.atti);
    //   this.attoToEdit = undefined;
    //   this.indexAttoToEdit = undefined;
    // }
    if(!!this.attoToEdit) {
      //se modifico un atto esistente
      this.atti[this.indexAttoToEdit] = atto;
      // this.creazionePraticaStoreService.setAtti(this.atti);
      this.attoToEdit = undefined;
      this.indexAttoToEdit = undefined;
    }
    this.isEdit = false;
    this.salva();
    this.onShowList();
    // this.creazionePraticaStoreService.save();
  }

  associa(atto: Atto) {
    //passa atto prevalorizzato al form e mostra il form
    this.onFormAtto();
    this.attoAssociato = atto;
    this.isScroll = true;
  }

  deleteAtto(props: {atto: Atto, index: number}) {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_ATTI_FASCICOLO);
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneAtti;
    this.delete(props.atto, idSezione, index, props.index);
  }

  delete(atto: Atto, idSezione:string, indexAccordion:number, index:number) {
    this.operations.deleteNewAtto(
      this.accordions[indexAccordion].properties.urlInsert, 
      idSezione, 
      atto.id
    ).subscribe(
      res => {
        this.atti.splice(index, 1);
        this.creazionePraticaStoreService.setAtti(this.atti);
        this.creazionePraticaStoreService.save();
        this.readSezione();
      }
    )
  }

  editAtto(index: number) {
    this.onFormAtto();
    this.attoToEdit = this.atti[index];
    this.indexAttoToEdit = index;
    this.isScroll = true;
    this.isEdit = true;
    this.formAtti.inizializza(true);
  }

  reset() {
    this.creazionePraticaStoreService.setAtti([]);
    this.creazionePraticaStoreService.save();
  }

  pulisciCampi() {
    this.attoAssociato = undefined;
    this.attoToEdit = undefined;
  }


  annullaModifica() {
    this.attoToEdit = undefined;
    this.attoAssociato = undefined;
    this.isEdit = false;
    this.onShowList();
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest'});
  }


  private filterEntities(entities: ElaborationDocumentFilterEntity[]) {
    this.tipiAttiStore = entities.filter(el =>
      el.tipoEntita.label_key.toUpperCase() === 'GIURISPRUDENZA'
    );
    this.datePubblicazioniSuggerite = entities.filter(el =>
      el.tipoEntita.label_key.toUpperCase() === 'PUBLISH_DATE'
    );
    this.dateDepositoSuggerite = entities.filter(el =>
      el.tipoEntita.label_key.toUpperCase() === 'DECISION_DATE'
    );
  }

  private createAttiByEntities(tipiAtto: TipoAtto[],
    datePubblicazione: ElaborationDocumentFilterEntity[],
    dateDeposito: ElaborationDocumentFilterEntity[]) {
      for(var tipoAtto of tipiAtto) {
        let atto: Atto = new Atto();
        atto.tipoAtto = new TipoAtto();
        atto.tipoAtto = JSON.parse(JSON.stringify(tipoAtto));
        for(var dataPubblicazione of datePubblicazione) {
          atto.dataPubblicazione = this.dateStringToDate(dataPubblicazione.valore);
          for(var dataDeposito of dateDeposito) {
            atto.dataDeposito = this.dateStringToDate(dataDeposito.valore);
            let attoTmp: Atto = new Atto();
            attoTmp = JSON.parse(JSON.stringify(atto));
            this.attiSuggeriti.push(attoTmp);
          }
          if(atto.dataDeposito  === undefined) {
            let attoTmp: Atto = new Atto();
            attoTmp = JSON.parse(JSON.stringify(atto));
            this.attiSuggeriti.push(attoTmp);
          }
        }
        if(atto.dataPubblicazione === undefined) {
          for (var dataDeposito of dateDeposito) {
            atto.dataDeposito = this.dateStringToDate(dataDeposito.valore);
            let attoTmp: Atto = new Atto();
            attoTmp = JSON.parse(JSON.stringify(atto));
            this.attiSuggeriti.push(attoTmp);
          }
          if(atto.dataDeposito === undefined) {
            let attoTmp: Atto = new Atto();
            attoTmp = JSON.parse(JSON.stringify(atto));
            this.attiSuggeriti.push(attoTmp);
          }
        }
        if(atto.dataPubblicazione === undefined && atto.dataDeposito === null) {
          let attoTmp: Atto = new Atto();
          attoTmp = JSON.parse(JSON.stringify(atto));
          this.attiSuggeriti.push(attoTmp);
        }
      }
  }

  salva() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_ATTI_FASCICOLO);
    let idSezione =
      !!this.accordions[index].properties.fascicolo.idSezioneAtti
        ? this.accordions[index].properties.fascicolo.idSezioneAtti
        : "new";
    let idFascicolo = this.accordions[index].properties.fascicolo.id;
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    if(this.atti.findIndex(x => x.id === this.attoTmp.id) < 0) {
      this.add(index, idSezione, idFascicolo);
    } else {
      this.update(tipoPratica, tipoFascicolo, idSezione, index, idFascicolo);
    }
  }

  private add(index: number, idSezione: string, idFascicolo: string) {
    this.operations.addNewAtto(
      this.attoTmp,
      this.accordions[index].properties.urlInsert,
      idSezione,
      idFascicolo
    ).subscribe(res => {
      this.atti = res.sezione.atti;
      this.creazionePraticaStoreService.setAtti(res.sezione.atti);
      this.creazionePraticaStoreService.save();
      let request = new ScadenzarioRequest(
        this.accordions[index].properties.tipoPratica,
        this.accordions[index].properties.tipoFascicolo, 
        this.accordions[index].properties.fascicolo.grado, 
        this.attoTmp.tipoAtto, 
        null, 
        null, 
        null,
        null,
        null,
        null, 
        this.accordions[index].properties.fascicolo.natura,
        this.accordions[index].properties.fascicolo.tipoRicorso
      );
      this.checkScadenze(request, index, res);
      if (this.formAtti?.fileUploadList?.length > 0) {
        this.formAtti.uploadPendingDocs(res.lastID);
      }
      this.operations.readFascicolo(this.accordions[index].properties.urlInsert, idFascicolo).subscribe(
        res => {
          this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
          this.accordions[index].complete = true;
          this.readSezione();
          this.attoTmp = null;
        }
      );
    });
  }
  
  private checkScadenze(request: ScadenzarioRequest, index: number, res: any) {
    this.operations.ciSonoScadenze('exists', request)
      .subscribe(response => {
        if (response && response.length > 0) {
          response.forEach(element => {
            if ((element.label === 'DEPOSITO' && this.attoTmp.dataDeposito) ||
              (element.label === 'PUBBLICAZIONE' && this.attoTmp.dataPubblicazione) ||
              (element.label === 'NOTIFICA' && this.attoTmp.dataNotifica)) {
              this.openAutoAddModal(this.attoTmp, request, index, res);
              return;
            }
          });
        }
      });
  }

  private openAutoAddModal(atto, request, index, sezione) {
    this.attiScadenzaAutoAddModal.initFormCreazioneRapida(
      atto, 
      request, 
      this.accordions[index].properties.fascicolo.natura, 
      sezione.lastID, 
      this.accordions[index].properties.fascicolo.id,
      'attiScadenzaAutoAddModal'
    )
  }

  private update(
    tipoPratica: string, 
    tipoFascicolo: string, 
    idSezione: string, 
    index: number, 
    idFascicolo: string
  ) {
    this.operations.updateNewAtto(
      this.attoTmp,
      tipoPratica,
      tipoFascicolo,
      idSezione
    ).subscribe(res => {
      this.operations.readFascicolo(this.accordions[index].properties.urlInsert, idFascicolo).subscribe(
        res => {
          this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
          this.accordions[index].complete = true;
          this.readSezione();
          this.attoTmp = null;
        }
      );
    });
  }
  readSezione() {
    let index = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_ATTI_FASCICOLO);
    let tipoPratica = this.accordions[index].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[index].properties.tipoFascicolo.endpoint;
    let idSezione = this.accordions[index].properties.fascicolo.idSezioneAtti || null;
    this.fascicolo = this.accordions[index].properties.fascicolo;
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/atti`;
    if(!idSezione) return;
    this.operations.readSezione(url, idSezione).subscribe(response => {
      this.sezione = response.sezione;
      this.fascicolo = this.accordions[index].properties.fascicolo;
      this.atti = response.sezione.atti;
      this.accordions[index].properties.sezione = response.sezione;
      this.accordions[index].properties.sezione["esn"] = NomiDescrittoriSezione.SEZIONE_ATTI_FASCICOLO;
      this.creazionePraticaStoreService.onSectionLoaded(response.sezione);
      this.creazionePraticaStoreService.setAtti(this.atti);
      this.creazionePraticaStoreService.save();
      this.accordions[index].complete = true;
      this.operations.readFascicolo(this.accordions[index].properties.urlInsert, this.accordions[index].properties.fascicolo.id).subscribe(
        res => {
          this.accordions.forEach(x => x.properties.fascicolo = res.fascicolo);
          this.updateSezioneAdempimenti(res.idSezioneScadenze);
        }
      );
     
    });
  }

  private dateStringToDate(dateString: String) {
    let parts: any = dateString.split('/'); //  formato dd/mm/yyyy
    return new Date(parts[2], parts[1] - 1, parts[0]).valueOf();
  }


  updateSezioneAdempimenti(idSezioneScadenze:string) {
    let indexAdempimenti = this.accordions.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO);
    let tipoPratica = this.accordions[indexAdempimenti].properties.tipoPratica.endpoint;
    let tipoFascicolo = this.accordions[indexAdempimenti].properties.tipoFascicolo.endpoint;
    let idSezione = this.accordions[indexAdempimenti].properties.fascicolo.idSezioneScadenze || idSezioneScadenze;
    let url = `/rs/ops/gp/${tipoPratica}/fasc/${tipoFascicolo}/sez/scadenze`;
    if(!idSezione) return;
    this.operations.readSezione(url, idSezione).subscribe(response => {
      this.fascicolo = this.accordions[indexAdempimenti].properties.fascicolo;
      this.accordions[indexAdempimenti].properties.sezione = response.sezione;
      this.accordions[indexAdempimenti].properties.sezione["esn"] = NomiDescrittoriSezione.SEZIONE_SCADENZARIO_FASCICOLO;
      this.creazionePraticaStoreService.onSectionLoaded(response.sezione);
      this.creazionePraticaStoreService.setAdempimenti(response.sezione.scadenze);
      this.creazionePraticaStoreService.save();
      this.scadenze = response.sezione.scadenze;
      this.accordions[indexAdempimenti].complete = true;
    });
  }

  onDropDownEvent(event: {
    atto: Atto,
    eventType: 'allegato' | 'elimina',
    index: number
  }) {
    switch (event.eventType) {
      case "elimina":
        break;
      case "allegato":
        this.attachDocument(event);
        break;
      default:
        break;
    }
  }

  private attachDocument(event: { atto: Atto; eventType: 'allegato' | 'elimina'; }) {
    this.docAddModalAtti.initFormAlternative(
      this.getUrlAddDocToAtto(),
      this.sezione, 
      this.fascicolo.id, 
      false, 
      this.sezione.esn, 
      'Aggiungi documento - Atti', 
      true, 
      event.atto
    );
  }

  private getUrlAddDocToAtto() {
    return ServicePathsSettings.URL_ADD_DOCUMENTO_TO_ATTO;
  }

  closeModalDocumentAndReadSezione() {
    closeModal('docVersionUpdateModalAtti');
    closeModal('docAddModalAtti');
    closeModal('attiScadenzaAutoAddModal');
    this.readSezione();
  }

  onDocumentEvent(event: {
    documento: DocumentoAllegato,
    atto?: Atto,
    entityId?: string,
    sezioneId?: string,
    eventType: 'nuova-versione' | 'storico' | 'modifica' | 'elimina' | 'metadati'
  }) {
    switch (event.eventType) {
      case "elimina":
        this.removeDoc(event.documento, event.entityId);
        break;
      case "metadati":
        this.displayDocUpdateMetadatiModal(event.documento);
        break;
      case "nuova-versione":
        this.showUploadNewVersionModal(event.documento);
        break;
      case "storico":
        this.showHistoryModal(event.documento);
        break;
      default:
        break;
    }
  }

  private removeDoc(documento: DocumentoAllegato, entityId: string) {
    this.operations.removeDocumentoToEntity(documento, this.getUrlRemoveDocFromAtto(), entityId)
      .subscribe(() =>{ 
        this.readSezione();
      });
  }

  private showHistoryModal(documento: DocumentoAllegato) {
    this.docVersionHistoryAtti.initContentCreazioneRapida(documento, this.fascicolo, 'docVersionHistoryAtti');
  }

  private displayDocUpdateMetadatiModal(documento: DocumentoAllegato) {
    const ref = this.dialog.open(UpdateMetadatiComponent, {
      data: {
        style: { width: "70%"},
        title: 'Modifica metadati',
        documento: documento,
        fascicolo: this.fascicolo,
        tipoPratica: this.fascicolo?.praticaBase.tipoPratica.id
      }
    });
     ref.afterClosed.subscribe(event => {
      if(!event || event.closeEvent) {
        // documento.primary = false;
        return
      };
      if(!!event.response) {
        this.closeModalDocumentAndReadSezione();
      }
    });
  }

  private showUploadNewVersionModal(documento: DocumentoAllegato) {
    this.docVersionUpdateModalAtti.initFormCreazioneRapida(documento, 'docVersionUpdateModalAtti');
  }

  private getUrlRemoveDocFromAtto() {
    return ServicePathsSettings.URL_REMOVE_DOCUMENTO_FROM_ATTO;
  }

}
